import { Heading, Stack } from '@chakra-ui/react';
import { useTranslations } from 'use-intl';

import { AdminIndividualsList } from './AdminIndividualsList';

type Props = unknown;

export function AdminIndividuals(): JSX.Element {
  const i18nAdminList = useTranslations('AdminList.Users');

  return (
    <Stack spacing="6">
      <Heading>{i18nAdminList('Title')}</Heading>
      <AdminIndividualsList />
    </Stack>
  );
}

export type AdminIndividualsProps = Props;
